import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ADPResourceService, CustomFormControl, StorageService } from 'digital-core';
import { GlobalModalWindowService } from 'src/app/core/services/global-modal-window.service';
import { buildDeviceDisplayName } from 'src/app/shared/device/device-display-name.pipe';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';


export interface SerialResult {
  serial: string;
}

export enum SerialLookupDeviceTemplate {
  Smartphone = 'Smartphone',
  Smartwatch = 'Smartwatch',
  Tablet = 'Tablet'
}

@Component({
  selector: 'pgh-serial-lookup',
  templateUrl: './serial-lookup.component.html',
  styleUrls: ['./serial-lookup.component.scss']
})
export class SerialLookupComponent implements OnInit {
  @Input() serialLookupDeviceTypeTemplate:SerialLookupDeviceTemplate;
  @Input() isOnboardingFlow?:boolean = false;
  @Input() onboardingFlowDevice?:PghUserDeviceBase;
  @Output() nextEvent = new EventEmitter<SerialResult>();

  public preHeaderTextContext?: { device:string };

  public isSmartphone:boolean=false;
  public isTablet:boolean=false;
  public isSmartwatch:boolean=false;

  public serialNumberForm: UntypedFormGroup;

  device: PghUserDeviceBase;

  constructor(
    public resourceService: ADPResourceService,
    private selectedDeviceService: SelectedDeviceService,
    private errorDialogService: GlobalModalWindowService,
    private storageService: StorageService
  ) { }


  ngOnInit(): void {

    if(this.serialLookupDeviceTypeTemplate === SerialLookupDeviceTemplate.Smartphone){
      this.isSmartphone = true;
    }
    else if(this.serialLookupDeviceTypeTemplate === SerialLookupDeviceTemplate.Tablet){
      this.isTablet = true;
    }
    else if(this.serialLookupDeviceTypeTemplate === SerialLookupDeviceTemplate.Smartwatch){
      this.isSmartwatch = true;
    }

    this.serialNumberForm = new UntypedFormGroup({
      serialNumber: new CustomFormControl({ value: this.device?.imei, disabled: false }, [Validators.required])
    });

    if (this.isOnboardingFlow) {
      this.device = this.onboardingFlowDevice;
    } else {
      this.device = this.selectedDeviceService.getSelectedDevice();
    }

    this.preHeaderTextContext = { device: buildDeviceDisplayName(this.device)};
  }

  public submitForm() {
    if (!this.serialNumberForm.valid) {
      return;
    }
    if (!this.isOnboardingFlow) {
      const allDevices = this.selectedDeviceService.getAllDevices();
      const alreadyExist = !!allDevices.find(x => x.serialNumber == this.serialNumberForm?.value?.serialNumber);
      if (alreadyExist) {
        this.errorDialogService.displaySimpleErrorModal('RegisterCellularDevice_SerialNumber_Invalid_Message');
        return;
      }
    }    

    this.disableEnableInputs(true);

    this.nextEvent.emit({
      serial: this.serialNumberForm.controls.serialNumber.value,
    });

    this.disableEnableInputs(false);
  }

  validateImeiNumber(control: UntypedFormControl) {
    if (control?.value != null) {
      if (!this.isImeiNumberValid(control.value)) {
        return { invalid: true };
      }
    }
  }

  isImeiNumberValid(imei: string): boolean {
    let etal = /^[0-9]{15}$/;

    if (!etal.test(imei)) {
      return false;
    }

    let sum = 0;
    let mul = 2;
    let l = 14;

    for (let i = 0; i < l; i++) {
      let digit = imei.substring(l - i - 1, l - i);

      let tp = parseInt(digit, 10) * mul;

      if (tp >= 10) {
        sum += (tp % 10) + 1;
      } else {
        sum += tp;
      }

      if (mul === 1) {
        mul++;
      } else {
        mul--;
      }
    }

    let chk = (10 - (sum % 10)) % 10;

    if (chk !== parseInt(imei.substring(14, 15), 10)) {
      return false;
    }

    // console.log('Valid IMEI');
    return true;
  }

  /**
   * This method will enable / disable the input fields depending on whether
   * your pass a true or a false in. When you pass a true in, then it will
   * disable the inputs. When you pass a false in, then it will enable the
   * inputs.
   *
   * @param disabled When disabled is true, then the input fields will be
   * disabled. When disabled is false, then the input fields will be enabled.
   */
  private disableEnableInputs(disabled: boolean) {
    if (disabled === true) {
      this.serialNumberForm.disable();
    } else {
      this.serialNumberForm.enable();
    }
  }

}
